<template>
  <div class="wework-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/" class="wework-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运维管理</el-breadcrumb-item>
      <el-breadcrumb-item>运营数据</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主内容区 -->
    <el-card class="wework-card" shadow="hover">
      <!-- 筛选工具栏 -->
      <div class="tab-toolbar">
        <el-input
          v-model="queryInfo.code"
          placeholder="平台编号"
          clearable
          size="small"
          style="width: 160px"
          @clear="handleSearch"
        ></el-input>
        <el-input
          v-model="queryInfo.name"
          placeholder="店铺名称"
          clearable
          size="small"
          style="width: 180px"
          @clear="handleSearch"
        ></el-input>
        <el-date-picker
          v-model="queryInfo.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          style="width: 260px"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          @change="handleSearch"
        ></el-date-picker>
        <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="handleReset">重置</el-button>
        <el-button type="success" size="small" icon="el-icon-upload2" @click="importDialogVisible = true">数据导入</el-button>
      </div>

      <!-- Tab 切换 -->
      <el-tabs v-model="activeTab" class="wework-tabs" @tab-click="handleTabClick">
        <!-- 美团 -->
        <el-tab-pane label="美团" name="meituan">
          <el-table
            :data="platformData.meituan.list"
            border
            size="small"
            v-loading="platformData.meituan.loading"
            :height="tableHeight"
            class="wework-table"
          >
            <el-table-column prop="date" label="日期" width="100" fixed></el-table-column>
            <el-table-column prop="code" label="平台编号" width="120"></el-table-column>
            <el-table-column prop="name" label="店铺名称" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="评分" width="70">
              <template slot-scope="scope">{{ fmtNum(scope.row.pingfen) }}</template>
            </el-table-column>
            <el-table-column label="店铺分" width="70">
              <template slot-scope="scope">{{ fmtNum(scope.row.dianpufen) }}</template>
            </el-table-column>
            <el-table-column label="商圈排名" width="85">
              <template slot-scope="scope">{{ fmtNum(scope.row.paiming) }}</template>
            </el-table-column>
            <!-- 外卖 -->
            <el-table-column label="外卖" align="center">
              <el-table-column label="有效订单" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_dingdan) }}</template>
              </el-table-column>
              <el-table-column label="营业收入" width="95">
                <template slot-scope="scope">{{ fmtMoney(scope.row.waimai_shouru) }}</template>
              </el-table-column>
              <el-table-column label="曝光人数" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_baoguang) }}</template>
              </el-table-column>
              <el-table-column label="入店人数" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_rudian) }}</template>
              </el-table-column>
              <el-table-column label="下单人数" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_xiadan) }}</template>
              </el-table-column>
              <el-table-column label="下单新客" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_xinke) }}</template>
              </el-table-column>
              <el-table-column label="下单老客" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_laoke) }}</template>
              </el-table-column>
              <el-table-column label="客单价" width="80">
                <template slot-scope="scope">{{ fmtMoney(scope.row.waimai_kedan) }}</template>
              </el-table-column>
              <el-table-column label="实付" width="80">
                <template slot-scope="scope">{{ fmtMoney(scope.row.waimai_shifu) }}</template>
              </el-table-column>
              <!-- <el-table-column label="推广" width="80">
                <template slot-scope="scope">{{ fmtMoney(scope.row.waimai_tuiguang) }}</template>
              </el-table-column> -->
              <el-table-column label="入店转化率" width="100">
                <template slot-scope="scope">{{ fmtRate(scope.row.waimai_rudian_rate) }}</template>
              </el-table-column>
              <el-table-column label="下单转化率" width="100">
                <template slot-scope="scope">{{ fmtRate(scope.row.waimai_xiadan_rate) }}</template>
              </el-table-column>
            </el-table-column>
            <!-- 拼好饭 -->
            <el-table-column label="拼好饭" align="center">
              <el-table-column label="有效订单" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.haofan_dingdan) }}</template>
              </el-table-column>
              <el-table-column label="营业收入" width="95">
                <template slot-scope="scope">{{ fmtMoney(scope.row.haofan_shouru) }}</template>
              </el-table-column>
              <el-table-column label="曝光人数" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.haofan_baoguang) }}</template>
              </el-table-column>
              <el-table-column label="入店人数" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.haofan_rudian) }}</template>
              </el-table-column>
              <el-table-column label="下单人数" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.haofan_xiadan) }}</template>
              </el-table-column>
              <el-table-column label="下单新客" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.haofan_xinke) }}</template>
              </el-table-column>
              <el-table-column label="下单老客" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.haofan_laoke) }}</template>
              </el-table-column>
              <el-table-column label="客单价" width="80">
                <template slot-scope="scope">{{ fmtMoney(scope.row.haofan_kedan) }}</template>
              </el-table-column>
              <el-table-column label="实付" width="80">
                <template slot-scope="scope">{{ fmtMoney(scope.row.haofan_shifu) }}</template>
              </el-table-column>
              <!-- <el-table-column label="推广" width="80">
                <template slot-scope="scope">{{ fmtMoney(scope.row.haofan_tuiguang) }}</template>
              </el-table-column> -->
              <el-table-column label="入店转化率" width="100">
                <template slot-scope="scope">{{ fmtRate(scope.row.haofan_rudian_rate) }}</template>
              </el-table-column>
              <el-table-column label="下单转化率" width="100">
                <template slot-scope="scope">{{ fmtRate(scope.row.haofan_xiadan_rate) }}</template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="val => handleSizeChange('meituan', val)"
            @current-change="val => handleCurrentChange('meituan', val)"
            :current-page="platformData.meituan.pagenum"
            :page-sizes="[20, 50, 100]"
            :page-size="platformData.meituan.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="platformData.meituan.total"
            class="wework-pagination"
          ></el-pagination>
        </el-tab-pane>

        <!-- 淘宝闪购 -->
        <el-tab-pane label="淘宝闪购" name="taobao">
          <el-table
            :data="platformData.taobao.list"
            border
            size="small"
            v-loading="platformData.taobao.loading"
            :height="tableHeight"
            class="wework-table"
          >
            <el-table-column prop="date" label="日期" width="100" fixed></el-table-column>
            <el-table-column prop="code" label="平台编号" width="120"></el-table-column>
            <el-table-column prop="name" label="店铺名称" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="评分" width="70">
              <template slot-scope="scope">{{ fmtNum(scope.row.pingfen) }}</template>
            </el-table-column>
            <el-table-column label="店铺分" width="70">
              <template slot-scope="scope">{{ fmtNum(scope.row.dianpufen) }}</template>
            </el-table-column>
            <el-table-column label="商圈排名" width="85">
              <template slot-scope="scope">{{ fmtNum(scope.row.paiming) }}</template>
            </el-table-column>
            <!-- 外卖 -->
            <el-table-column label="外卖" align="center">
              <el-table-column label="有效订单" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_dingdan) }}</template>
              </el-table-column>
              <el-table-column label="营业收入" width="95">
                <template slot-scope="scope">{{ fmtMoney(scope.row.waimai_shouru) }}</template>
              </el-table-column>
              <el-table-column label="曝光人数" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_baoguang) }}</template>
              </el-table-column>
              <el-table-column label="入店人数" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_rudian) }}</template>
              </el-table-column>
              <el-table-column label="下单人数" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_xiadan) }}</template>
              </el-table-column>
              <el-table-column label="下单新客" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_xinke) }}</template>
              </el-table-column>
              <el-table-column label="下单老客" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_laoke) }}</template>
              </el-table-column>
              <el-table-column label="客单价" width="80">
                <template slot-scope="scope">{{ fmtMoney(scope.row.waimai_kedan) }}</template>
              </el-table-column>
              <el-table-column label="实付" width="80">
                <template slot-scope="scope">{{ fmtMoney(scope.row.waimai_shifu) }}</template>
              </el-table-column>
              <!-- <el-table-column label="推广" width="80">
                <template slot-scope="scope">{{ fmtMoney(scope.row.waimai_tuiguang) }}</template>
              </el-table-column> -->
              <el-table-column label="入店转化率" width="100">
                <template slot-scope="scope">{{ fmtRate(scope.row.waimai_rudian_rate) }}</template>
              </el-table-column>
              <el-table-column label="下单转化率" width="100">
                <template slot-scope="scope">{{ fmtRate(scope.row.waimai_xiadan_rate) }}</template>
              </el-table-column>
            </el-table-column>
            <!-- 爆品团 -->
            <el-table-column label="爆品团" align="center">
              <el-table-column label="有效订单" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.haofan_dingdan) }}</template>
              </el-table-column>
              <el-table-column label="营业收入" width="95">
                <template slot-scope="scope">{{ fmtMoney(scope.row.haofan_shouru) }}</template>
              </el-table-column>
              <el-table-column label="曝光人数" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.haofan_baoguang) }}</template>
              </el-table-column>
              <el-table-column label="入店人数" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.haofan_rudian) }}</template>
              </el-table-column>
              <el-table-column label="下单人数" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.haofan_xiadan) }}</template>
              </el-table-column>
              <el-table-column label="下单新客" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.haofan_xinke) }}</template>
              </el-table-column>
              <el-table-column label="下单老客" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.haofan_laoke) }}</template>
              </el-table-column>
              <el-table-column label="客单价" width="80">
                <template slot-scope="scope">{{ fmtMoney(scope.row.haofan_kedan) }}</template>
              </el-table-column>
              <el-table-column label="实付" width="80">
                <template slot-scope="scope">{{ fmtMoney(scope.row.haofan_shifu) }}</template>
              </el-table-column>
              <!-- <el-table-column label="推广" width="80">
                <template slot-scope="scope">{{ fmtMoney(scope.row.haofan_tuiguang) }}</template>
              </el-table-column> -->
              <el-table-column label="入店转化率" width="100">
                <template slot-scope="scope">{{ fmtRate(scope.row.haofan_rudian_rate) }}</template>
              </el-table-column>
              <el-table-column label="下单转化率" width="100">
                <template slot-scope="scope">{{ fmtRate(scope.row.haofan_xiadan_rate) }}</template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="val => handleSizeChange('taobao', val)"
            @current-change="val => handleCurrentChange('taobao', val)"
            :current-page="platformData.taobao.pagenum"
            :page-sizes="[20, 50, 100]"
            :page-size="platformData.taobao.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="platformData.taobao.total"
            class="wework-pagination"
          ></el-pagination>
        </el-tab-pane>

        <!-- 京东 -->
        <el-tab-pane label="京东" name="jd">
          <el-table
            :data="platformData.jd.list"
            border
            size="small"
            v-loading="platformData.jd.loading"
            :height="tableHeight"
            class="wework-table"
          >
            <el-table-column prop="date" label="日期" width="100" fixed></el-table-column>
            <el-table-column prop="code" label="平台编号" width="120"></el-table-column>
            <el-table-column prop="name" label="店铺名称" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="评分" width="70">
              <template slot-scope="scope">{{ fmtNum(scope.row.pingfen) }}</template>
            </el-table-column>
            <el-table-column label="店铺分" width="70">
              <template slot-scope="scope">{{ fmtNum(scope.row.dianpufen) }}</template>
            </el-table-column>
            <el-table-column label="商圈排名" width="85">
              <template slot-scope="scope">{{ fmtNum(scope.row.paiming) }}</template>
            </el-table-column>
            <!-- 外卖 -->
            <el-table-column label="外卖" align="center">
              <el-table-column label="有效订单" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_dingdan) }}</template>
              </el-table-column>
              <el-table-column label="营业收入" width="95">
                <template slot-scope="scope">{{ fmtMoney(scope.row.waimai_shouru) }}</template>
              </el-table-column>
              <el-table-column label="曝光人数" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_baoguang) }}</template>
              </el-table-column>
              <el-table-column label="入店人数" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_rudian) }}</template>
              </el-table-column>
              <el-table-column label="下单人数" width="85">
                <template slot-scope="scope">{{ fmtNum(scope.row.waimai_xiadan) }}</template>
              </el-table-column>
              <el-table-column label="客单价" width="80">
                <template slot-scope="scope">{{ fmtMoney(scope.row.waimai_kedan) }}</template>
              </el-table-column>
              <el-table-column label="实付" width="80">
                <template slot-scope="scope">{{ fmtMoney(scope.row.waimai_shifu) }}</template>
              </el-table-column>
              <!-- <el-table-column label="推广" width="80">
                <template slot-scope="scope">{{ fmtMoney(scope.row.waimai_tuiguang) }}</template>
              </el-table-column> -->
              <el-table-column label="入店转化率" width="100">
                <template slot-scope="scope">{{ fmtRate(scope.row.waimai_rudian_rate) }}</template>
              </el-table-column>
              <el-table-column label="下单转化率" width="100">
                <template slot-scope="scope">{{ fmtRate(scope.row.waimai_xiadan_rate) }}</template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="val => handleSizeChange('jd', val)"
            @current-change="val => handleCurrentChange('jd', val)"
            :current-page="platformData.jd.pagenum"
            :page-sizes="[20, 50, 100]"
            :page-size="platformData.jd.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="platformData.jd.total"
            class="wework-pagination"
          ></el-pagination>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 数据导入弹窗 -->
    <el-dialog title="数据导入" :visible.sync="importDialogVisible" width="520px" :close-on-click-modal="false">
      <el-form label-width="80px" size="small">
        <el-form-item label="选择平台">
          <el-select v-model="importPlatform" placeholder="请选择平台" style="width: 100%" :disabled="importUploading" @change="handlePlatformChange">
            <el-option label="美团" value="meituan"></el-option>
            <el-option label="淘宝闪购" value="taobao"></el-option>
            <el-option label="京东" value="jd"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据类型">
          <el-select
            v-model="importType"
            placeholder="请选择数据类型"
            style="width: 100%"
            :disabled="!importPlatform || importUploading"
          >
            <el-option
              v-for="opt in importTypeOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择文件">
          <el-upload
            :action="importUrl"
            :headers="uploadHeaders"
            :data="{ platform: importPlatform, type: importType }"
            :show-file-list="false"
            :on-success="handleImportSuccess"
            :on-error="handleImportError"
            :on-progress="handleImportProgress"
            :before-upload="beforeImportUpload"
            :disabled="!importPlatform || !importType || importUploading"
            accept=".xlsx,.xls,.csv"
          >
            <el-button type="primary" :disabled="!importPlatform || !importType" :loading="importUploading">
              {{ importUploading ? '导入中...' : '点击上传' }}
            </el-button>
            <span slot="tip" class="import-tip"> 支持 .xlsx、.xls、.csv 格式，大小不超过 20MB</span>
          </el-upload>
        </el-form-item>
        <el-progress v-if="importUploading" :percentage="importProgress" :stroke-width="6" style="margin-top: 8px" />
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeTab: 'meituan',

      // 筛选条件（三个平台共用）
      queryInfo: {
        code: '',
        name: '',
        dateRange: null
      },

      // 各平台独立的列表数据与分页状态
      platformData: {
        meituan: { list: [], total: 0, pagenum: 1, pagesize: 20, loading: false },
        taobao: { list: [], total: 0, pagenum: 1, pagesize: 20, loading: false },
        jd: { list: [], total: 0, pagenum: 1, pagesize: 20, loading: false }
      },

      // 数据导入弹窗
      importDialogVisible: false,
      importPlatform: '',
      importType: '外卖',
      importUrl: this.$http.defaults.baseURL + 'yunwei/waimai/import',
      uploadHeaders: {
        authorization: window.sessionStorage.getItem('token'),
        Accept: 'application/json'
      },
      importUploading: false,
      importProgress: 0,

      // 日期快捷选项
      pickerOptions: {
        shortcuts: [
          {
            text: '昨天',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [date, date])
            }
          },
          {
            text: '最近7天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近30天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  computed: {
    tableHeight () {
      return window.innerHeight - 300
    },
    importTypeOptions () {
      const map = {
        meituan: [{ label: '外卖', value: '外卖' }, { label: '拼好饭', value: '拼好饭' }],
        taobao: [{ label: '外卖', value: '外卖' }, { label: '爆品团', value: '爆品团' }],
        jd: [{ label: '外卖', value: '外卖' }]
      }
      return map[this.importPlatform] || [{ label: '外卖', value: '外卖' }]
    }
  },
  created () {
    this.getList('meituan')
  },
  methods: {
    // 获取指定平台数据
    async getList (platform) {
      const pd = this.platformData[platform]
      pd.loading = true

      try {
        const params = {
          platform,
          pagenum: pd.pagenum,
          pagesize: pd.pagesize
        }

        if (this.queryInfo.code) {
          params.code = this.queryInfo.code
        }
        if (this.queryInfo.name) {
          params.name = this.queryInfo.name
        }
        if (this.queryInfo.dateRange && this.queryInfo.dateRange.length === 2) {
          params.startDate = this.queryInfo.dateRange[0]
          params.endDate = this.queryInfo.dateRange[1]
        }

        const { data: res } = await this.$http.get('yunwei/yunyingData/list', { params })
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          return
        }

        pd.list = res.data.list || []
        pd.total = res.data.total || 0
      } catch (error) {
        this.$message.error('获取运营数据失败')
        console.error('获取运营数据失败:', error)
      } finally {
        pd.loading = false
      }
    },

    // Tab 切换处理
    handleTabClick (tab) {
      const platform = tab.name
      const pd = this.platformData[platform]
      // 未加载过数据时自动请求
      if (pd.list.length === 0 && pd.total === 0) {
        this.getList(platform)
      }
    },

    // 查询按钮
    handleSearch () {
      const pd = this.platformData[this.activeTab]
      pd.pagenum = 1
      this.getList(this.activeTab)
    },

    // 重置按钮
    handleReset () {
      this.queryInfo = {
        code: '',
        name: '',
        dateRange: null
      }
      // 重置所有平台的分页
      Object.keys(this.platformData).forEach(key => {
        this.platformData[key].pagenum = 1
      })
      this.getList(this.activeTab)
    },

    // 分页大小变更
    handleSizeChange (platform, newSize) {
      this.platformData[platform].pagesize = newSize
      this.platformData[platform].pagenum = 1
      this.getList(platform)
    },

    // 页码变更
    handleCurrentChange (platform, newPage) {
      this.platformData[platform].pagenum = newPage
      this.getList(platform)
    },

    // 数值格式化（整数）
    fmtNum (val) {
      return val !== null && val !== undefined ? val : '-'
    },

    // 金额格式化（两位小数）
    fmtMoney (val) {
      return val !== null && val !== undefined ? val.toFixed(2) : '-'
    },

    // 转化率格式化
    fmtRate (val) {
      if (val === null || val === undefined) return '-'
      return (val * 100).toFixed(2) + '%'
    },

    // ========== 数据导入相关 ==========

    // 平台切换时重置数据类型
    handlePlatformChange () {
      const valid = this.importTypeOptions.some(opt => opt.value === this.importType)
      if (!valid) {
        this.importType = '外卖'
      }
    },

    beforeImportUpload (file) {
      if (!this.importPlatform) {
        this.$message.warning('请先选择平台')
        return false
      }
      if (!this.importType) {
        this.$message.warning('请选择数据类型')
        return false
      }
      const validTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
        'text/csv'
      ]
      const isLt20M = file.size / 1024 / 1024 < 20
      if (!validTypes.includes(file.type) && !file.name.match(/\.(xlsx|xls|csv)$/i)) {
        this.$message.error('只能上传 xlsx、xls 或 csv 文件!')
        return false
      }
      if (!isLt20M) {
        this.$message.error('上传文件大小不能超过 20MB!')
        return false
      }
      // 文件名前缀校验：确保文件与所选平台+数据类型匹配
      const prefixRule = {
        'meituan-外卖': { prefix: '美团', exclude: ['美团-拼好饭'] },
        'meituan-拼好饭': { prefix: '美团-拼好饭' },
        'taobao-外卖': { prefix: '淘宝', exclude: ['淘宝-爆品团'] },
        'taobao-爆品团': { prefix: '淘宝-爆品团' },
        'jd-外卖': { prefix: '京东' }
      }
      const rule = prefixRule[`${this.importPlatform}-${this.importType}`]
      if (rule) {
        if (!file.name.startsWith(rule.prefix)) {
          this.$message.error(`文件名必须以"${rule.prefix}"开头，请确认是否选择了正确的平台和数据类型`)
          return false
        }
        if (rule.exclude && rule.exclude.some(ex => file.name.startsWith(ex))) {
          this.$message.error(`该文件属于"${rule.exclude[0]}"数据，请选择对应的数据类型`)
          return false
        }
      }
      this.importUploading = true
      this.importProgress = 0
      return true
    },

    handleImportProgress (event) {
      this.importProgress = Math.round(event.percent || 0)
    },

    handleImportSuccess (res) {
      this.importUploading = false
      this.importProgress = 100
      if (res.meta && res.meta.status !== 200) {
        return this.$message.error(res.meta.msg || '导入失败')
      }
      const platformLabel = { meituan: '美团', taobao: '淘宝闪购', jd: '京东' }
      const count = res.data.count
      const typeLabel = this.importType !== '外卖' ? this.importType : ''
      this.$message.success(`${platformLabel[this.importPlatform] || ''}${typeLabel} 导入完成，写入 ${count} 条数据`)
      // 自动关闭弹窗
      this.importDialogVisible = false
      this.importPlatform = ''
      this.importType = '外卖'
      this.importProgress = 0
      // 刷新当前平台列表
      this.getList(this.activeTab)
    },

    handleImportError () {
      this.importUploading = false
      this.importProgress = 0
      this.$message.error('导入失败，请检查文件格式是否正确')
    }
  }
}
</script>

<style scoped>
.wework-page {
  padding: 0 4px;
}

.wework-breadcrumb {
  margin-bottom: 16px;
}

.wework-card {
  border-radius: 8px;
  border: 1px solid #e8ecf1;
}

/* Tab 样式 */
.wework-tabs >>> .el-tabs__header {
  margin-bottom: 0;
  padding-top: 4px;
}

.wework-tabs >>> .el-tabs__item {
  height: 46px;
  line-height: 46px;
  font-size: 14px;
  font-weight: 500;
}

.wework-tabs >>> .el-tabs__nav-wrap::after {
  height: 1px;
}

/* 工具栏 */
.tab-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 0 12px;
}

/* 分页 */
.wework-pagination {
  padding: 14px 0 0;
  text-align: right;
}

/* 数据导入 */
.import-tip {
  font-size: 13px;
  color: #909399;
  line-height: 32px;
  margin-left: 8px;
}
</style>
